import { TimesheetEntry } from '@app/models/time-tracking/timesheet-entry.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

const options = [
    {
        label: 'pending',
        value: 'pending',
    },
    {
        label: 'approved',
        value: 'approved',
    },
];

export class StatusColumn extends BadgeColumn<TimesheetEntry> {
    title = 'time-tracking.timesheetsIndexPage.table.status';
    property = 'status';
    type: CellDisplay = CellDisplay.badge;

    constructor() {
        super();

        this.filter = new CheckListFilter('status', options);
    }

    getBadgeDisplay(timesheetEntry: TimesheetEntry): BadgeDisplay {
        if (timesheetEntry.isApproved) {
            return {
                type: 'success',
                label: 'approved',
            };
        }

        return {
            type: 'informative',
            label: 'pending',
        };
    }
}
